import * as React from 'react';
import Modal from '@/components/Modal';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import Button from '@/components/Button';
import useRequest from '@/components/hooks/useRequest';
import { SubtitleDetail } from '@/features/video/models/VideoFrame';
import { editSubtitle } from '@/features/video/store/videoAPI';
import { message } from 'antd';
import { useAppSelector } from '@/app/hooks';
import { selectVideo, update } from '@/features/video/store/videoSlice';
import { useDispatch } from 'react-redux';
import { selectSubtitle as getSubtitlesByUserId, setSubtitleViewing } from '@/features/video/store/subtitleSlice';

interface IUnlinkProps {
  isOpen: boolean;
  onClickClose: () => void;
  subtitleDetail?: SubtitleDetail;
  refetchListSubtitles?: () => void;
}

const UnlinkSubtitleModal: React.FunctionComponent<IUnlinkProps> = ({
  isOpen,
  onClickClose,
  subtitleDetail,
  refetchListSubtitles = () => null
}) => {
  const { request } = useRequest();
  const dispatch = useDispatch();
  const theme = useTheme();
  const { addingPlayableItems, subtitles, subtitlesInit, subtitleStyle } = useAppSelector(selectVideo);
  // const languageOptions = useAppSelector(getLanguagesSubtitles);
  // const selectedLanguage = languageOptions?.find((opt: Language) => opt.langCode === 'en');
  const { subtitleViewing } = useAppSelector(getSubtitlesByUserId);

  const onUnlink = async () => {
    const bodyReq = {
      file: ''
    };
    const editSub = await request(editSubtitle(subtitleDetail?.id as string, bodyReq));
    if (editSub?.data?.status === 200) {
      refetchListSubtitles();
      handleUnLinkSubtitle();
      if (subtitleDetail?.id === subtitleViewing[0]?.id) {
        dispatch(setSubtitleViewing([]));
      }
    } else {
      message.error('Unlink subtitle unsuccessfully!');
    }
    onClickClose();
  };

  const onClose = () => {
    onClickClose();
  };

  const handleUnLinkSubtitle = () => {
    const modifyListVideos = addingPlayableItems
      .filter((x) => !x.isHide)
      .map((item: any) => {
        if (item.idSubtitleLinked === subtitleDetail?.id) {
          return { ...item, idSubtitleLinked: '' };
        } else {
          return { ...item };
        }
      });

    const newSubtitle = subtitles?.filter((item) => item?.file !== subtitleDetail?.file);
    const newSubtitleInit = subtitlesInit?.filter((item) => item?.file !== subtitleDetail?.file);

    dispatch(
      update({
        subtitleStyle: subtitleStyle
          ? subtitleStyle
          : {
              fontSize: '14px',
              backgroundColor: 'rgba(255, 255, 255, 1)',
              color: 'rgba(0, 0, 0, 1)'
            },
        // language: { name: selectedLanguage.label, code: selectedLanguage.langCode },
        subtitles: newSubtitle as any,
        subtitlesInit: newSubtitleInit as any,
        addingPlayableItems: modifyListVideos
      })
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClickClose={onClose}
      backgroundColor={theme.neutral.white}
      customFixedWidth="470px"
      overflow="auto"
      isConfirmDlg={true}
      borderRadius="12"
    >
      <TitleConfirm>Are you sure to unlink this item?</TitleConfirm>
      <ActionsContainer>
        <Button onClick={onClickClose} variant="outline">
          Cancel
        </Button>
        <Button variant="alert" onClick={onUnlink}>
          Unlink
        </Button>
      </ActionsContainer>
    </Modal>
  );
};

export default UnlinkSubtitleModal;

export const ModalTileUpload = styled.span`
  font-family: 'Objective';
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.75px;
  color: #070550;
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 32px;
  justify-content: end;
`;

export const TitleConfirm = styled.div`
  text-align: center;
  font-size: 20px;
  line-height: 32px;
  font-family: 'Objective';
  font-weight: 700;
`;
